import { JobAttachmentsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { jobsKeys } from './jobsKeys';
import type { TCall, TCallOptions } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof jobsKeys.attachment>>;

export const createFetchJobAttachmentQueryFn =
  (call: TCall, options?: TCallOptions) =>
  ({ queryKey: [{ jobId, workspaceId, attachmentId }], signal }: TParams) =>
    call(
      () => cancelOnSignal(JobAttachmentsService.getAttachment({ wsid: workspaceId, jobId, attachmentId }), signal),
      options,
    );
